import React from "react";

function FooterImage(props) {
  return (
    <a href={props.url} target="_blank" className="text-center"><img className="max-h-10 md:max-h-18 inline-block" src={props.image} alt={props.name} /></a>
  );
};

export default FooterImage;